import React from 'react'
// import React, { useState } from 'react';
import axios from 'axios';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input, Feedback } from 'reactstrap';
import { Form, Col, fieldset } from 'react-bootstrap';
import { getSessionName, getSessionID, getCompanyID, getToken } from '../../../Utils/Common';

class AddSite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      name: '',
      team :'' ,
      country: '',
      company:[],
      default:'',
      active:'',
      successMsg:'',
      fields: {},
      errors: {}
  };

    this.toggle = this.toggle.bind(this);
    this.handleChangeDefault = this.handleChangeDefault.bind(this);
    this.handleChangeActive = this.handleChangeActive.bind(this);
    this.handleChangeGender = this.handleChangeGender.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    // this.handleChange = this.handleChange.bind(this);
  }

toggle() {
  this.setState({
    modal: !this.state.modal
  });
}

handleCloseModal () {
  this.setState({
    modal: !this.state.modal
  });
}

handleChange(field, e){         
  let fields = this.state.fields;
  fields[field] = e.target.value;        
  this.setState({fields});
 //this.setState({ [e.target.name]: e.target.value });
}

handleChangeDefault(event) {
  if(event.target.checked == true){
    this.setState({default: '1'});
  }
  else{
    this.setState({default: '0'});
  }
}

handleChangeActive(event) {
  if(event.target.checked == true){
    this.setState({active: '1'});
  }
  else{
    this.setState({active: '0'});
  }
}

handleChangeTeam(event) {
  this.setState({team: event.target.value});
}
handleChangeGender(event) {
  this.setState({gender: event.target.value});
}


handleValidation(){
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    //Name
    if(!fields["name"]){
       formIsValid = false;
       errors["name"] = "Cannot be empty";
    }

    if(typeof fields["name"] !== "undefined"){
       if(!fields["name"].match(/^[a-zA-Z]+$/)){
          formIsValid = false;
          errors["name"] = "Only letters";
       }        
    }

    // //Email
    // if(!fields["email"]){
    //    formIsValid = false;
    //    errors["email"] = "Cannot be empty";
    // }

    // if(typeof fields["email"] !== "undefined"){
    //    let lastAtPos = fields["email"].lastIndexOf('@');
    //    let lastDotPos = fields["email"].lastIndexOf('.');

    //    if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["email"].indexOf('@@') == -1 && lastDotPos > 2 && (fields["email"].length - lastDotPos) > 2)) {
    //       formIsValid = false;
    //       errors["email"] = "Email is not valid";
    //     }
    // }  

   this.setState({errors: errors});
   return formIsValid;
}


  handleSubmit(event) {   

    event.preventDefault();
    
    if(this.handleValidation()){
      
      alert("Form submitted");
      this.handleCloseModal();
      const session_Name = getSessionName();
      if (!session_Name) {
        return;
      }
    
      const session_ID = getSessionID();
      if (!session_ID) {
        return;
      }
    
      const company_id = getCompanyID();
      if (!company_id) {
        return;
      }
  
      const login_token = getToken();
      if (!login_token) {
        return;
      }
  
      const sites = {
        field_site_name: this.state.fields["name"],
        field_site_company: company_id,
        field_site_default: this.state.default,
        field_site_active: this.state.active
      };
  
      let axiosConfig = {
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': login_token,
            'Authentication': session_Name+"="+session_ID,
        }
      };
  
      let self = this;
  
      axios.post(`http://payroll.nikkolim.com/post_sites/sites`, sites, axiosConfig)
        .then(res => {
          console.log(res);
          console.log(res.data);
         // console.log(JSON.stringify(successMsg));
        })
        event.preventDefault();
   }else{
      alert("Form has errors.");
   }
  }

  componentDidMount () {
    let self = this;

    const session_Name = getSessionName();
    if (!session_Name) {
      return;
    }
  
    const session_ID = getSessionID();
    if (!session_ID) {
      return;
    }
  
    const company_id = getCompanyID();
    if (!company_id) {
      return;
    }

    const login_token = getToken();
    if (!login_token) {
      return;
    }
    
    var postData = {
      'company_id': company_id
    };

    var company_id_login = {
      'company_id': company_id
    }

    let axiosConfig = {
      headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': login_token,
          'Authentication': session_Name+"="+session_ID,
      }
    };

    axios.post('http://payroll.nikkolim.com/get_form/sites_company/site_form', postData, axiosConfig)
    .then((response) => {
         self.setState({ company_id: company_id_login});
         self.setState({ company: response.data.field_site_company});
        //console.log(JSON.stringify(response.data));
    })
    .catch((err) => {
      console.log("AXIOS ERROR: ", err);
    })
  }

  searchSubmit = e => {
    const { value } = e.target;
  };

  render() {

        const { 
          company,
          company_id,
          name,
          validated,
        } = this.state;

    return (
        <div>
        <Button size="sm" color="primary" onClick={this.toggle} className="btn btn-primary" >Create Site</Button>
        <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
       isOpen={this.state.modal}>
        <form noValidate validated={validated} onSubmit={this.handleSubmit}>
          <ModalHeader>Add Site</ModalHeader>
          <ModalBody>
          <Form>
          <fieldset name="primaryInfo">
            {/* <Label for="employee_information">Personal Information</Label> */}
              <Form.Row>
                  <Col>
                      <Label>Name</Label>
                      <Form.Control value={this.state.fields["name"]} required ref="name" type="text" name="name" placeholder="Name" onChange={this.handleChange.bind(this, "name")}  />
                      <span style={{color: "red"}}>{this.state.errors["name"]}</span>
                      {/* <Form.Control.Feedback>Looks good!</Form.Control.Feedback> */}
                  </Col>
                  <Col>
                      <Label>Company</Label>
                      <Form.Control disabled  name="company_value" as="select" >
                        {company.map(company => (
                          <option value={company.id} key={company.id}>
                            {company.name}
                          </option>
                          ))}
                      </Form.Control>
                  </Col>
              </Form.Row>
              <Form.Row>
                  <Col md="2">
                      <Label>Default</Label>
                      <Form.Check 
                        type="switch"
                        id="switch-default"
                        label=""
                        onChange={this.handleChangeDefault}
                        name="default"
                      />
                  </Col>
                  <Col md="2">
                      <Label>Active</Label>
                      <Form.Check 
                        type="switch"
                        id="switch-active"
                        label=""
                        onChange={this.handleChangeActive}
                        name="active"
                      />
                  </Col>
              </Form.Row>
            </fieldset>
            </Form>
          </ModalBody>
          <ModalFooter>
		  	      <Button className= "btn btn-secondary" onClick={this.toggle}>Cancel</Button>
              <Button className= "btn btn-secondary" type="submit">Create</Button>
              {/* <Button className= "btn btn-secondary" onClick={this.toggle}>Save</Button> */}
            {/* <input type="submit" value="Logout" color="primary" className="btn btn-primary" /> */}
          </ModalFooter>
          </form>
        </Modal>
        </div>
      
    );
  }
}

export default AddSite;